import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './RefundErrorModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class RefundErrorModal extends Component {
    render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isRefundErrorOpen} toggle={this.toggle}>
		          	<ModalHeader toggle={this.props.toggleRefundErrorModal}>{strings.title}</ModalHeader>
		          	<ModalBody>
						{this.props.transaction_refund_id === -1 || !this.props.transaction_refund_id ? (
							<p>{strings.contentCant}</p>
						) : (
							<p>{strings.contentAlready}</p>
						)}
						<div className="d-flex justify-content-center mt-4">
							<button 
								className="showtix-button showtix-background__primary-1"
								onClick={this.props.toggleRefundErrorModal}
								>{strings.ok}</button>   
		          		</div>
					</ModalBody>
		        </Modal>
			</div>
	  	);
	}
}

RefundErrorModal.propTypes = {
    isRefundErrorOpen: PropTypes.bool,
	toggleRefundErrorModal: PropTypes.func,
	transaction_refund_id: PropTypes.number,
}

export default RefundErrorModal;


// WEBPACK FOOTER //
// ./src/components/Search/RefundErrorModal/RefundErrorModal.js